module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/vendor-desktop@2x-f2c82825e4d7a029dc7f6a6b68523b0b.jpg";